// apps/dashboard/src/lib/build.ts
// Hard-coded for now. Wire to Vite `define` in a follow-up if we want
// this to carry a real commit SHA.
export const BUILD_TAG = "BUILD.2026.04";
